import(/* webpackMode: "eager" */ "/app/src/app/esm-stock-analysis/page.tsx");
